/**
 * Helper functions for localisations
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>
 */
const lyraConfig = require('@/config/lyra.config');

/**
 * Returns the localisation by default
 * @returns { String } localisation by default
 */
function defaultLocalisationConfig (): string {
    const _defaultLocalisation = '';

    lyraConfig.default.localisations.forEach((localisation: any) => {
        if (localisation.default) {
            return localisation.localisation
        }
    });

    return _defaultLocalisation;
}

const defaultLocalisation = defaultLocalisationConfig();
const { sessionStorageLabel } = lyraConfig.default;

/**
 * Check URL Query, Setting appropriate value
 * @return { String } localisation
 */
function getLocalisationUrl (route: any): string {
    const { query } = route;
    const body = document.querySelector('body');
    const bodyAttribute = body?.getAttribute('data-localisation') || '';

    let _localisation = defaultLocalisation;
    if (query.localisation) {
        _localisation = query.localisation;
    } else if (bodyAttribute) {
        _localisation = bodyAttribute;
    } else if (window.lyraClient.localisation) {
        _localisation = window.lyraClient.localisation;
    } else {
        const storedLocalisation = sessionStorage.getItem(sessionStorageLabel);
        if (storedLocalisation) {
            _localisation = storedLocalisation;
            sessionStorage.removeItem(sessionStorageLabel);
        }
    }

    return _localisation;
}

/**
 * Verify a localisation string or get localisation
 * @return { String } localisation
 */
export function activeLocalisation () {
    window.lyraClient = window.lyraClient || {};

    const body = document.querySelector('body');
    const bodyAttribute = body?.getAttribute('data-localisation') || '';

    let _localisation = defaultLocalisation;
    if (bodyAttribute) {
        _localisation = bodyAttribute;
    } else if (window.lyraClient.localisation) {
        _localisation = window.lyraClient.localisation;
    }

    return _localisation;
 }
 
/**
 * Apply localisation guard check
 */
export function localisationGuard (route) {
    const body = document.querySelector('body');

    /**
     * Exposing windows object
     */
     window.lyraClient = window.lyraClient || {};
     window.lyraActiveLocalisation = activeLocalisation();

    /**
     * Apply localisation variables
     */
    const _localisation = getLocalisationUrl(route);

    if (_localisation) {
        window.lyraClient.localisation = _localisation;
        body?.setAttribute('data-localisation', _localisation);
    }
}
 
/**
 * Save current localisation in a memory
 */
export function saveLocalisation () {
    const localisation = activeLocalisation();
    sessionStorage.setItem(sessionStorageLabel, localisation);
}
